import View from "./View.js";
import icons from "url:../../img/BBA25-sprite.svg"; // Parcel 2

class WinnersItemView extends View {
	_parentElement = "";

	_generateMarkup() {
		const descriptionMarkup = this._data.description
			? `<div class="product__decription">${this._data.description}</div>`
			: "";

		return `
            <a href="https://www.bt1.lv/balticbeauty/read.php?subid=${this._data.id}" class="product product--winner">
                <div class="product__img product__img--${this._data.placeTitle}">
                    <img src="https://www.bt1.lv/bt1/zina_baze/images/thumbs/${this._data.imgFile}" alt="${this._data.title}" />
                </div>
                <div class="medal medal--${this._data.placeTitle}">
                    <div class="medal__title">Awards</div>
                    <svg class="medal__decoration">
                        <use href="${icons}#medal-decoration"></use>
                    </svg>
                    <svg class="medal__brand">
                        <use href="${icons}#medal_title"></use>
                    </svg>
                </div>
                <div class="product__title">
                    <div class="product__heading">${this._data.title}</div>
                    ${descriptionMarkup}
                </div>
            </a>
    `;
	}
}

export default new WinnersItemView();
